import React from "react";
import "./StatusIndicator.css";

const StatusIndicator = ({ text, type }) => {
  let className = "";

  switch (type) {
    case "green":
      className = "status-indicator green";
      break;
    case "red":
      className = "status-indicator red";
      break;
    case "orange":
      className = "status-indicator orange";
      break;
    case "blue":
      className = "status-indicator blue";
      break;
    case "grey":
      className = "status-indicator grey";
      break;
    default:
      className = "status-indicator unknown";
  }

  return (
    <div className={className}>
      {/* <span className="status-dot"></span> */}
      {text}
    </div>
  );
};

export default StatusIndicator;



// WEBPACK FOOTER //
// ./src/components/statusIndicator/StatusIndicator.jsx